import { useEffect, useMemo, useState } from "react";
import { Grid, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchCampus } from "../../features/campus/campusSlice";
import { fetchCalendars } from '../../features/calendars/calendarsSlice';
import Content from "./Content";
import Forms from "./Forms";
import { SimpleSelect } from "../Form";
import { deleteStudents, fetchStudents, clearResult, filterBySede, filterdStudents, filterByCycle, filterByCampus } from '../../features/students/studentsSlice'
import { fetchCareers } from '../../features/careers/careersSlice'
import FormSearch from "./FormSearch";
import { CustomContainer } from "../Tools";

const checkIsRoot = type => type === 'root';

const Students = () => {
    const { type } = useSelector(state => state.auth);
    const { total } = useSelector(state => state.students)
    const { campus } = useSelector(state => state.campus)
    const { careers } = useSelector(state => state.careers);
    const { calendars, status } = useSelector(state => state.calendars)
    const dispatch = useDispatch()
    const isRoot = useMemo(() => checkIsRoot(type), [type])
    const [sede, setSede] = useState('');
    const [ciclo, setCiclo] = useState('')
    const [career, setCareer] = useState('');

    const handleChangeCareer = event => {
        const val = event.target.value;
        setCareer(val)
        if(val) {
            dispatch(filterdStudents({career: val}))
            setCiclo('')
            setSede('')
        }else {
            dispatch(clearResult())
            setCiclo('')
            setSede('')
        }
    }

    const handleChangeCycle = event => {
        const val = event.target.value
        setCiclo(val);
        dispatch(filterByCycle(val))
        setSede('')
    }

    const handleChangeCampus = event => {
        const val = event.target.value
        setSede(val);
        if(val !== ''){
            dispatch(filterByCampus({ ciclo, sede: val }))
        }else{
            dispatch(dispatch(filterByCycle(ciclo)))
        }
    }

    const handleChange = event => {
        const val = event.target.value;
        setSede(val);
        dispatch(filterBySede(val))
    }

    const changeCycle = event => {
        const val = event.target.value;
        setCiclo(val);
        if(val !== ''){
            dispatch(fetchStudents({ cycle: val}))
        }else{
            dispatch(clearResult())
        }
    }
    
    useEffect(() => {
        if(status === 'idle'){
            dispatch(fetchCampus())
            if(isRoot) dispatch(fetchCareers())
            dispatch(fetchCalendars())
        }
    }, [dispatch, status, isRoot])
    const title = 'Estudiantes';
    return(
        <CustomContainer
            content={<Content />}
            forms={<Forms isRoot={isRoot} />}
            fnConfirm={deleteStudents}
            title={title}
        >   
            { isRoot ? (
                <>
                    <Grid container spacing={2} sx={{ mt: '1em' }}>
                        <Grid item xs={12} sm={12} md={12}>
                            <FormSearch />
                        </Grid>
                        <Grid item xs={12} sm={12} md={4}>
                            <SimpleSelect label={'Carrera'} val={career} onChange={handleChangeCareer} options={careers} />
                        </Grid>
                        { career ? 
                            <Grid item xs={12} sm={12} md={4}>
                                <SimpleSelect label={'Calendario Escolar'} val={ciclo} onChange={handleChangeCycle} options={calendars} />
                            </Grid>
                        : null }
                        { ciclo ?
                            <Grid item xs={12} sm={12} md={4}>
                                <SimpleSelect label={'Sede'} val={sede} onChange={handleChangeCampus} options={campus} />
                            </Grid>
                        : null}
                    </Grid>
                    { career && <Typography sx={{ mt: 2 }} align="center">Total de estudiantes: <b>{total}</b></Typography> }
                </>
            ) : ( 
                <Grid container spacing={2} sx={{ mt: '1em' }}>
                    <Grid item xs={12} sm={12} md={12}>
                        <FormSearch />
                    </Grid>
                    <Grid item xs={12} sm={12} md={4}>
                        <SimpleSelect label={'Calendario Escolar'} val={ciclo} onChange={changeCycle} options={calendars} />
                    </Grid>
                    { ciclo ? (
                        <Grid item xs={12} sm={12} md={4}>
                            <SimpleSelect label={'Sede'} val={sede} onChange={handleChange} options={campus} />
                        </Grid>
                    ) : null}
                </Grid>
            )}
        </CustomContainer>
    )
}

export default Students;